import React from 'react';
import { PatientContext } from '../../models/patient_context';
import SingleItemSelectComponent from '../minicomponents/single_item_select';
import SingleSelectOutputComponent from '../minicomponents/single_select_output';

export default class FormItemComponent extends React.Component {
  static contextType = PatientContext;

  /**
   * Takes the existing numeric score of a patient's form response and converts it to
   * the actual text interpretation.
   * This does not apply to form items without array of options.
   */
  numberToText = (formFieldValue, formFieldValueItems, formFieldMin) => {
    // Form fields that do no have corresponding options have numeric values
    if (formFieldValueItems.length === 0) return formFieldValue.toString();
    let index = formFieldValue - formFieldMin;
    if (index < 0) {
      return ""
    } else {
      if (index >= formFieldValueItems.length) {
        index = formFieldValueItems.length - 1;
      }
    }

    return formFieldValueItems[formFieldValue - formFieldMin]
  }

  extractScoreFromItem = (formFieldValue) => {
    const scorePattern = /\((\d+)\)/;
    const scoreExec = scorePattern.exec(formFieldValue);
    if (scoreExec === null) return null;
    const scoreExecNumber = parseInt(scoreExec[1]);
    // console.log("score (type:", typeof scoreExecNumber, ") =>", scoreExecNumber);
    return scoreExecNumber;
  }

  /**
   * Takes the value of a property of a form object being scored and returns a score based on:
   * 1. A provided scoring model,
   * 2. Scores embedded in the corresponding option,
   * 3. The index of the corresponding option in the array of options.
   * @param {string} formFieldValue - The value of a property in a form object being scored
   */
  scoreFormField = (formFieldValue) => {
    let score = this.extractScoreFromItem(formFieldValue);
    if (score === null) {
      score = this.props.desc.findIndex(des => des === formFieldValue);
      return score !== undefined ? score.toString() : ""
    }
    return score.toString();
  }

  update = (index) => {
    const thisForm = this.context[this.context.last_viewed].forms[this.props.formTag];
    const value = thisForm[this.props.field];
    const found = this.props.desc.findIndex(des => des === value);
    if (found === index) this.props.onItemChange(this.props.field, -1);
    else this.props.onItemChange(this.props.field, index + this.props.min);
  }

  commonUpdater = (value, found) => {
    if (found) this.props.onItemChange(this.props.field, "");
    else this.props.onItemChange(this.props.field, value);
  }

  updateWithText = (index) => {
    const thisForm = this.context[this.context.last_viewed].forms[this.props.formTag];
    let value = this.parseValue(thisForm[this.props.field]);
    // if (typeof value === "number") {
    //   value = this.numberToText(value, this.props.desc, this.props.min);
    // }
    // const found = this.props.desc.find(des => des === value);
    const text = this.props.desc[index];
    const found = text === value;
    this.commonUpdater(text, found);
  }

  updateWithInputText = (event) => {
    const eventValue = event.target.value;
    const thisForm = this.context[this.context.last_viewed].forms[this.props.formTag];
    const value = this.parseValue(thisForm[this.props.field]);
    const found = eventValue === value;
    this.commonUpdater(eventValue, found);
  }

  /**
   * Takes the value of a form field and parses it into a string equivalent usable by
   * the user interface.
   * @param {number | string} formFieldValue - the value of the form field to parse
   * @returns {string}
   */
  parseValue = (formFieldValue) => {
    switch (typeof formFieldValue) {
      case "number":
        return this.numberToText(formFieldValue, this.props.desc, this.props.min);

      case "string":
        return formFieldValue;

      default:
        return "";
    }
  }

  render() {
    const thisForm = this.context[this.context.last_viewed].forms[this.props.formTag];
    const value = thisForm[this.props.field];
    // console.log("value =>", value);
    let selectedItem = this.parseValue(value);
    // if (typeof value === "number") {
    //   selectedItem = this.numberToText(value, this.props.desc, this.props.min)
    // } else {
    //   if (typeof value === "undefined") {
    //     selectedItem = "";
    //   } else selectedItem = value;
    // }
    // console.log("selectedItem =>", selectedItem);
    return (
      <div className="container-fluid">
        <div className="row px-5 pt-5 pb-4">
          <div className="col-12">
            <div className="emr-form-item">
              <label htmlFor={this.props.field}>{this.props.label}</label>
              {
                this.props.examiner ?
                  <>
                    <p className="text-wrap">{this.props.examiner}</p>
                    <br />
                  </> : null
              }
              <SingleItemSelectComponent
                selectableItems={this.props.desc}
                selectedItem={selectedItem}
                displayInBox={this.updateWithText}
              />
              <input type="text" name={this.props.field}
                id={this.props.field} value={selectedItem} onChange={this.updateWithInputText}
                className={selectedItem ? "filled" : ""}></input>
            </div>
            {/* <SingleSelectOutputComponent
              name={this.props.label}
              id={this.props.field}
              items={this.props.desc}
              value={this.props.desc[value - this.props.min]}
              onItemChange={this.update}
            /> */}
          </div>
        </div>
        <div className="row g-0 bg-light px-5 py-3 round-bottom-radii">
          {
            this.props.field ?
              <div className="col-12 col-md-6 col-lg-4">
                <div className="emr-form-item-score">
                  <span>Score: </span>
                  <input type="text" name={this.props.field + "-score"} min={this.props.min}
                    max={this.props.max} onChange={(event) => this.props.onItemChange(event.target.name,
                      event.target.value)} value={this.scoreFormField(selectedItem)}
                    id={this.props.field+"-score"} className={`d-inline w-auto 
                    p-1${value || parseInt(value) === 0 ? " filled" : ""}`}>
                  </input>
                </div>
              </div> : null
          }
        </div>
      </div>
    )
  }
}